function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_41547_42169)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.00065 14.6666C11.6826 14.6666 14.6673 11.6818 14.6673 7.99992C14.6673 4.31802 11.6826 1.33325 8.00065 1.33325C4.31875 1.33325 1.33398 4.31802 1.33398 7.99992C1.33398 11.6818 4.31875 14.6666 8.00065 14.6666Z",
  fill: "#4E8DD7",
  stroke: "#4E8DD7",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.21555 6.46753L8.18481 4.12404C8.11207 3.95865 7.88793 3.95865 7.81519 4.12404L6.78445 6.46753C6.7548 6.53494 6.69389 6.58135 6.6236 6.59009L4.17981 6.89395C4.00734 6.9154 3.93808 7.13895 4.06559 7.26261L5.87235 9.01483C5.92431 9.06523 5.94758 9.14032 5.93378 9.21313L5.45418 11.7444C5.42033 11.9231 5.60167 12.0612 5.75321 11.9723L7.90059 10.7117C7.96236 10.6754 8.03765 10.6754 8.09941 10.7117L10.2468 11.9723C10.3983 12.0612 10.5797 11.9231 10.5458 11.7444L10.0662 9.21313C10.0524 9.14032 10.0757 9.06523 10.1277 9.01483L11.9344 7.26261C12.0619 7.13895 11.9927 6.9154 11.8202 6.89395L9.3764 6.59009C9.30611 6.58135 9.2452 6.53494 9.21555 6.46753Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_41547_42169"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

var SvgPoints = function SvgPoints(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPoints, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/points.b37f1cc7.svg";
export { ForwardRef as ReactComponent };